import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import { FaUserMd, FaHeart, FaHospital, FaClinicMedical } from "react-icons/fa";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import Spacing from "../Spacing";
import Post from "../Post";
import { Helmet } from "react-helmet";
const workingProcessData = [
  {
    title: "Consultation",
    subTitle:
      "You can fill out an online appointment form on the website of Pluro Jabalpur Fertility Centre or call our office Number",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Baseline bloodwork and ultrasound ",
    subTitle:
      "For the IVF process, baseline bloodwork and an ultrasound are essential. These tests provide crucial information about your reproductive health, helping <br /> us tailor the most effective treatment plan for you.",
    iconUrl: "/images/home_2/department_icon2.png",
    number: "02",
  },
  {
    title: "Ovarian Stimulation",
    subTitle:
      "Ovarian stimulation is a crucial part of the IVF process. It involves using medications to stimulate your ovaries, encouraging the development of multiple eggs for retrieval and fertilization..",
    iconUrl: "/images/home_2/department_icon3.png",
    number: "03",
  },
  {
    title: "Oocyte Maturation",
    subTitle:
      "Oocyte maturation involves hormone treatments <br /> to ensure eggs reach full maturity, making <br />them ready for retrieval, fertilization, and<br /> subsequent  embryo development, which<br /> are crucial steps in the IVF process.",
    iconUrl: "/images/home_2/department_icon29.png",
    number: "04",
  },
  {
    title: "Egg Retrieval",
    subTitle:
      "Egg retrieval involves collecting mature eggs from the ovaries through a minor surgical procedure, allowing them to be fertilized in the lab as part of the IVF process.",
    iconUrl: "/images/home_2/department_icon25.png",
    number: "05",
  },
  {
    title: "Fertilization",
    subTitle:
      "All mature eggs are fertilized using intracytoplasmic sperm injection (ICSI), where sperm is injected directly into each mature egg. On average, about 70% of these mature eggs will successfully fertilize. The fertilized egg then develops into an embryo.",
    iconUrl: "/images/home_2/department_icon6.png",
    number: "06",
  },
  {
    title: "Embryo transfer",
    subTitle:
      "Embryo transfer is the final step in the IVF process. It involves placing the fertilized embryo into the uterus, where it can implant and develop into a successful pregnancy.",
    iconUrl: "/images/home_2/department_icon7.png",
    number: "07",
  },
  {
    title: "Two-Week wait",
    subTitle:
      "The two-week wait follows the embryo transfer in the IVF process. During this period, you'll wait to  take a <br />pregnancy test to determine if the procedure <br /> has been successful.",
    iconUrl: "/images/home_2/department_icon8.png",
    number: "08",
  },
  {
    title: "Pregnancy test",
    subTitle:
      "The pregnancy test, taken two weeks after the embryo transfer, determines if the IVF process has been successful and if implantation has occurred, indicating the start of a pregnancy.",
    iconUrl: "/images/home_2/department_icon9.png",
    number: "09",
  },
];
const faqData = [
  {
    title: "What is IVF (In Vitro Fertilization) and how does it work ?",
    content:
      "IVF, or In Vitro Fertilization, is a fertility treatment where eggs are retrieved from a woman's ovaries and fertilized with sperm in a laboratory. The resulting embryos are cultured for a few days and then transferred into the woman's uterus to achieve pregnancy. This process involves several steps, including ovarian stimulation, egg retrieval, fertilization, embryo culture, and embryo transfer.",
  },
  {
    title: "Who can benefit from IVF treatment ?",
    content:
      "IVF is recommended for individuals and couples facing various fertility challenges, including blocked or damaged fallopian tubes, severe male factor infertility (low sperm count or motility), endometriosis, unexplained infertility, failed attempts with other fertility treatments such as IUI, genetic disorders that require preimplantation genetic testing (PGT), and same-sex couples or single individuals using donor eggs, sperm, or embryos.",
  },
  {
    title: "What are the success rates for IVF at the Pluro Jabalpur IVF Center?",
    content:
      "The success rates of IVF can vary depending on several factors, including the age of the woman, the underlying cause of infertility, and whether fertility medications are used. At the Pluro Jabalpur IVF Center, the success rate for women under 35 is between 50% and 70%, for women aged 35 to 40, it ranges from 40% to 50%, and for women over 40, it ranges from 20% to 40%. On average, IVF success rates range from 25% to 35% per cycle, and multiple cycles may be recommended to increase the chances of success.",
  },
  {
    title: "What should I expect during the IVF process ?",
    content:
      "The IVF process involves several stages: Ovarian Stimulation, where hormonal medications are used to stimulate the ovaries to produce multiple eggs; Egg Retrieval, a minor surgical procedure to collect mature eggs from the ovaries; Fertilization, where eggs are fertilized with sperm in the laboratory to create embryos; Embryo Culture, where embryos are cultured for 3-5 days to monitor their development; Embryo Transfer, where selected embryos are transferred into the uterus; and a Pregnancy Test, a blood test performed approximately two weeks after the embryo transfer to confirm pregnancy.",
  },
  {
    title: "Are there any risks or side effects associated with IVF?",
    content:
      "IVF is a safe and well-established procedure, but like any medical treatment, it has potential risks and side effects, including Ovarian Hyperstimulation Syndrome (OHSS), a rare condition where the ovaries become swollen and painful after stimulation; Multiple Pregnancies, with a higher risk of twins if multiple embryos are transferred; Ectopic Pregnancy, a rare occurrence where the embryo implants outside the uterus; Emotional Stress, as the process can be emotionally challenging and counseling is recommended to help manage stress and anxiety; and side effects from medications, such as mild side effects like bloating, mood swings, and headaches from fertility medications.",
  },
];
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },

];
export default function IVF() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // pageTitle("IVF");
  return (
    <>
      <Helmet>
        <title>IVF (Test Tube Baby) – Advanced Fertility Treatment</title>
        <meta name="description" content="State-of-the-art IVF treatments with high success rates, tailored to your fertility needs and medical condition." />
        <meta name="keywords" content="IVF treatment, test tube baby, best IVF center, fertility clinic Jabalpur" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/IVF" />
      </Helmet>
      <Container>
        <BannerSectionStyle3
          bgUrl="/images/IVF.jpeg"
          // imgUrl="/images/about/banner_img.png"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="IVF (Test Tube Baby)"
        />

        <Section topMd={ 200 } topLg={ 150 } topXl={ 110 }>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* 1. Intro Section */ }
                <div className="cs_iui_intro">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <h1 className="cs_main_heading">Advanced IVF Treatments at Jabalpur Fertility Centre</h1>
                      <p>
                        In vitro fertilization (IVF), commonly known as the test
                        tube baby procedure, is one of the most effective forms of
                        assisted reproductive technology available today. At
                        Jabalpur Fertility Centre, the Best Fertility Clinic in
                        Jabalpur, we provide advanced IVF treatments under the
                        expert care of Dr. Archana Shrivastava, the Best IVF Doctor
                        in Jabalpur. Our goal is to help you achieve your dream of
                        parenthood through personalized, compassionate, and
                        state-of-the-art fertility care.
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <div className="cs_iui_highlight_box">
                        <h2>What is IVF ?</h2>
                        <p>
                          IVF is a process in which eggs are retrieved from a woman’s
                          ovaries and fertilized with sperm in a laboratory. The
                          resulting embryos are then cultured and monitored for
                          several days before being transferred into the woman's
                          uterus. IVF can be used to overcome a variety of fertility
                          issues and has helped countless couples conceive
                          successfully.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. When is IVF Recommended */ }
                <div className="cs_iui_recommended">
                  <h2 className="text-center cs_fs_40 cs_medium mb-3">When is IVF Recommended ?</h2>
                  <p className="text-center mb-5">
                    IVF is often recommended for couples facing the following fertility issues :
                  </p>

                  <div className="cs_iui_grid">
                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">01</div>
                      <div className="cs_rc_title">Blocked or Damaged Fallopian Tubes</div>
                      <p className="cs_rc_desc">IVF bypasses the fallopian tubes, making it a viable option for women with tubal factor infertility.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">02</div>
                      <div className="cs_rc_title">Male Factor Infertility</div>
                      <p className="cs_rc_desc">Including low sperm count, poor motility, or abnormal sperm morphology.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">03</div>
                      <div className="cs_rc_title">Ovulation Disorders</div>
                      <p className="cs_rc_desc">Such as polycystic ovary syndrome (PCOS) or premature ovarian failure.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">04</div>
                      <div className="cs_rc_title">Endometriosis</div>
                      <p className="cs_rc_desc">When endometrial tissue affects the ovaries, fallopian tubes, or other pelvic structures.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">05</div>
                      <div className="cs_rc_title">Unexplained Infertility</div>
                      <p className="cs_rc_desc">When no specific cause of infertility is identified after a complete fertility workup.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">06</div>
                      <div className="cs_rc_title">Previous Failed IUI or Other Treatments</div>
                      <p className="cs_rc_desc">For couples who have not had success with other fertility treatments.</p>
                    </div>

                    <div className="cs_recommended_card">
                      <div className="cs_rc_icon">07</div>
                      <div className="cs_rc_title">Genetic Disorders</div>
                      <p className="cs_rc_desc">To prevent the transmission of genetic conditions through preimplantation genetic testing (PGT).</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Start FAQ Section */ }
        <Section
          topMd={ 185 }
          topLg={ 140 }
          topXl={ 100 }
          bottomMd={ 200 }
          bottomLg={ 150 }
          bottomXl={ 110 }
        >
          <WorkingProcess
            sectionTitle="How IVF Works"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData }
          />
        </Section>
        {/* End FAQ Section */ }


        {/* Success Factors Section */ }
        <Section bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container">
            <div className="cs_ivf_factors_section_premium">
              <div className="text-center mb-5">
                <h2 className="cs_section_title_premium" style={ { '--after-left': '50%', '--after-transform': 'translateX(-50%)' } }>Success Rates and Factors Affecting IVF</h2>
                <div className="cs_ivf_desc_bg_premium mx-auto mt-4">
                  <p className="cs_section_desc_premium mb-0">
                    Success rates for IVF can vary based on several factors, including:
                  </p>
                </div>
              </div>
              <div className="row align-items-center cs_relative_z1">
                <div className="col-lg-5">
                  <div className="cs_factors_left_premium">
                    <div className="cs_factors_img_wrap" style={ { marginTop: "0" } }>
                      <img src="/images/about/ICSI.jpeg" alt="IVF Success Factors" className="cs_factors_img" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="cs_factors_grid_premium">
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">01</div>
                      <div className="cs_factor_content_premium">
                        <h3>Age of the Woman</h3>
                        <p>Younger women generally have higher success rates.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">02</div>
                      <div className="cs_factor_content_premium">
                        <h3>Quality of Eggs and Sperm</h3>
                        <p>Healthy eggs and sperm increase the likelihood of successful fertilization and embryo development.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">03</div>
                      <div className="cs_factor_content_premium">
                        <h3>Underlying Fertility Issues</h3>
                        <p>Some conditions may affect the success rates of IVF.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">04</div>
                      <div className="cs_factor_content_premium">
                        <h3>Number of IVF Cycles</h3>
                        <p>Success rates often increase with multiple cycles.</p>
                      </div>
                    </div>
                    <div className="cs_factor_card_premium">
                      <div className="cs_factor_num_premium">05</div>
                      <div className="cs_factor_content_premium">
                        <h3>Lifestyle Factors</h3>
                        <p>Maintaining a healthy lifestyle can positively impact IVF outcomes.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Why Choose Us Section */ }
        <Section bottomMd={ 120 } bottomLg={ 100 } bottomXl={ 80 }>
          <div className="container">
            <div className="cs_premium_why_choose">
              <div className="cs_premium_section_header">
                <div className="cs_premium_badge">Why Choose Us</div>
                <h2>Why Choose Jabalpur Fertility Centre for IVF ?</h2>
                <p>We offer world-class treatment with a compassionate approach, ensuring you receive the best care possible on your journey to parenthood.</p>
              </div>

              <div className="row cs_gap_y_40 justify-content-center" style={ { display: 'flex', flexWrap: 'wrap' } }>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaUserMd />
                    </div>
                    <h3>Expertise and Experience</h3>
                    <p>Led by Dr. Archana Shrivastava, our team has extensive experience in performing successful IVF procedures.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaHeart />
                    </div>
                    <h3>Personalized Care</h3>
                    <p>We tailor our treatment plans to meet the unique needs of each couple, ensuring the best possible outcomes.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaClinicMedical />
                    </div>
                    <h3>Comprehensive Fertility Services</h3>
                    <p>From initial consultation and complete fertility workup to advanced treatments like IVF and IUI, we offer a full spectrum of fertility services.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaHospital />
                    </div>
                    <h3>State-of-the-Art Facility</h3>
                    <p>Our clinic is equipped with the latest technology and facilities to provide top-notch fertility care.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium">
                    <div className="cs_wcp_icon">
                      <FaClinicMedical />
                    </div>
                    <h3>Patient-Centered Approach</h3>
                    <p>We prioritize your comfort and well-being, offering compassionate support throughout your fertility journey.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* FAQ Section */ }
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <div className="cs_iui_faq_wrapper">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>

        {/* Contact Us Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container cs_reveal">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering IVF as a fertility treatment option,
                  contact Jabalpur Fertility Centre today. Our expert team is
                  here to guide you through the process and help you achieve
                  your dream of starting a family.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .margin {
    margin-left: 25px;
  }
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
